/**
 * Preferencias del menú joystick (localStorage).
 */
import { isPixelAccurateTool } from './renderMode'

export const JOYSTICK_STORAGE_KEY = 'udv.joystickSlots'

/** Máximo de accesos en el menú radial. */
export const JOYSTICK_MAX_SLOTS = 9

/** Default previo (6): migrar a DEFAULT_JOYSTICK_SLOTS si no hubo personalización. */
const LEGACY_DEFAULT_JOYSTICK_SLOTS = [
  'Wwwc',
  'Magnify',
  'Invert',
  'series',
  'Length',
  'notool',
]

export const JOYSTICK_ACTION_IDS = [
  'Wwwc',
  'Magnify',
  'Invert',
  'Zoom',
  'Pan',
  'reset',
  'series',
  'Length',
  'notool',
  'Probe',
  'Angle',
  'saveas',
  'share',
]

/** 9 slots por defecto: imagen → navegación → medir / series / sin tool. */
export const DEFAULT_JOYSTICK_SLOTS = [
  'Wwwc',
  'Magnify',
  'Invert',
  'Zoom',
  'Pan',
  'reset',
  'Length',
  'series',
  'notool',
]

function sameSlotList(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false
  return a.every((id, i) => id === b[i])
}

export function getJoystickSlots() {
  try {
    const raw = localStorage.getItem(JOYSTICK_STORAGE_KEY)
    if (!raw) return DEFAULT_JOYSTICK_SLOTS.slice()
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed) || parsed.length === 0) {
      return DEFAULT_JOYSTICK_SLOTS.slice()
    }
    const cleaned = parsed
      .map((id) => String(id))
      .filter((id) => JOYSTICK_ACTION_IDS.includes(id))
      .slice(0, JOYSTICK_MAX_SLOTS)
    if (!cleaned.length) return DEFAULT_JOYSTICK_SLOTS.slice()
    // Preferencias = default viejo (sin personalizar) → default de 9
    if (sameSlotList(cleaned, LEGACY_DEFAULT_JOYSTICK_SLOTS)) {
      return DEFAULT_JOYSTICK_SLOTS.slice()
    }
    return cleaned
  } catch (e) {
    return DEFAULT_JOYSTICK_SLOTS.slice()
  }
}

export function setJoystickSlots(slots) {
  const cleaned = (Array.isArray(slots) ? slots : [])
    .map((id) => String(id))
    .filter((id) => JOYSTICK_ACTION_IDS.includes(id))
    .slice(0, JOYSTICK_MAX_SLOTS)
  const next = cleaned.length ? cleaned : DEFAULT_JOYSTICK_SLOTS.slice()
  try {
    localStorage.setItem(JOYSTICK_STORAGE_KEY, JSON.stringify(next))
  } catch (e) {
    /* ignore */
  }
  return next
}

/**
 * Portal paciente: sin herramientas pixel-accurate (medición / ROI).
 * @param {string[]|null|undefined} slots
 * @returns {string[]}
 */
export function filterJoystickSlotsForPortal(slots) {
  const list = Array.isArray(slots) && slots.length ? slots : getJoystickSlots()
  const filtered = list.filter((id) => !isPixelAccurateTool(id))
  if (filtered.length) return filtered
  return DEFAULT_JOYSTICK_SLOTS.filter((id) => !isPixelAccurateTool(id))
}
